/**
 * Servicio de Calidad - Comunicación con API
 * Formato: AMX-CC-FR-05 - Control de Producto No Conforme
 */

import apiClient from './api.js';

class CalidadService {

  // ==================== PRODUCTOS NO CONFORMES ====================

  /**
   * Listar PNC con filtros
   */
  async listarPNC(params = {}) {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, value);
      }
    });
    const queryString = queryParams.toString();
    return apiClient.get(`/calidad/pnc${queryString ? '?' + queryString : ''}`);
  }

  /**
   * Obtener PNC por ID
   */
  async obtenerPNC(id) {
    return apiClient.get(`/calidad/pnc/${id}`);
  }

  /**
   * Obtener PNCs por número de serie
   */
  async obtenerPNCPorNumSerie(numSerie) {
    return apiClient.get(`/calidad/pnc/tractor/${numSerie}`);
  }

  /**
   * Crear nuevo PNC
   */
  async crearPNC(data) {
    return apiClient.post('/calidad/pnc', data);
  }

  /**
   * Actualizar PNC
   */
  async actualizarPNC(id, data) {
    return apiClient.put(`/calidad/pnc/${id}`, data);
  }

  /**
   * Apartado 3.1 - Verificación de la acción
   */
  async registrarVerificacion(id, data) {
    return apiClient.post(`/calidad/pnc/${id}/verificacion`, data);
  }

  /**
   * Cerrar PNC
   */
  async cerrarPNC(id, data) {
    return apiClient.post(`/calidad/pnc/${id}/cerrar`, data);
  }

  /**
   * Agregar foto de evidencia
   */
  async agregarFoto(pncId, data) {
    return apiClient.post(`/calidad/pnc/${pncId}/fotos`, data);
  }

  /**
   * Eliminar foto de evidencia
   */
  async eliminarFoto(pncId, fotoId) {
    return apiClient.delete(`/calidad/pnc/${pncId}/fotos/${fotoId}`);
  }

  /**
   * Eliminar PNC
   */
  async eliminarPNC(id) {
    return apiClient.delete(`/calidad/pnc/${id}`);
  }

  // ==================== ESTADÍSTICAS ====================

  /**
   * Obtener estadísticas de calidad
   */
  async obtenerEstadisticas() {
    return apiClient.get('/calidad/estadisticas');
  }

  /**
   * Obtener PNC críticos pendientes
   */
  async obtenerPNCCriticos() {
    return apiClient.get('/calidad/pnc/criticos');
  }

  // ==================== PROBLEMAS INDIVIDUALES (1 PNC = N problemas) ====================

  /**
   * Obtener PNC abierto para un tractor (banner Checklist Ensamble).
   * Retorna null si no existe PNC abierto.
   */
  async obtenerPNCAbiertoPorTractor(numSerie) {
    return apiClient.get(`/calidad/pnc/abierto/${encodeURIComponent(numSerie)}`);
  }

  /**
   * Obtener problemas individuales de un PNC.
   */
  async obtenerProblemasDePNC(pncId) {
    return apiClient.get(`/calidad/pnc/${pncId}/problemas`);
  }

  /**
   * Actualizar un problema individual (acción, estatus, etc.).
   */
  async actualizarProblema(problemaId, data) {
    return apiClient.put(`/calidad/pnc/problemas/${problemaId}`, data);
  }

  /**
   * Eliminar un problema individual.
   */
  async eliminarProblema(problemaId) {
    return apiClient.delete(`/calidad/pnc/problemas/${problemaId}`);
  }
}

export default new CalidadService();
